import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  createContext,
} from "react";
import Slider from "react-slick";
import styles from "./Step.module.css";
import Step2 from "../Step2/Step2";
import Step3 from "../Step3/Step3";
import Step4 from "../Step4/Step4";
import {
  IDLE_FETCHER,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PopUp from "../Popup/Popup";
import StepHeader from "../StepHeader/StepHeader";
import axios from "axios";
import Loader from "../Loader/Loader";
import decodeToken from "../../lib/decodeToken";
import AnimatedButton from "../AnimatedButton/AnimatedButton";
import {
  API_BASE_URL,
  assignNumberToAgent,
  createAgent,
  createChatAgent,
  createNumberOrder,
  listAgents,
  updateAgent,
  updateAgentWidgetDomain,
  getOnBoardingTracker,
  createLlmWithKnowledgBaseId,
  createAgentWithLlmAndKnowledgeBaseId,
} from "../../Store/apiStore";
import { useDashboardStore } from "../../Store/agentZustandStore";
import useCheckAgentCreationLimit from "../../hooks/useCheckAgentCreationLimit";
import { getAgentPrompt } from "../../hooks/useAgentPrompt";
import BusinessDetails from "../BusinessDetails/BusinessDetails";
import BusinessServices from "../BusinessServices/BusinessServices";
import AboutBusinessNext from "../BusinessServices/BusinessServicesNEXT";
import AboutBusiness from "../AboutBusiness/AboutBusiness";
import BusinessListing from "../BusinessListing/BusinessListing";
import Tooltip from "../TooltipSteps/Tooltip";
import Step1 from "../Step1/Step1";
import getDynamicAgentName from "../../utils/getDynamicAgentName";
import Thankyou from "../ThankyouPage/Thankyou";
import getTimezoneFromState from "../../lib/timeZone";
import Modal2 from "../Modal2/Modal2";
import LottieAnimation from "../../lib/LottieAnimation";
import ConfirmModal from "../AboutBusiness/ConfirmModal";
import { businessTypes } from "../../lib/businessTypesCode";
import {
  appointmentBooking,
  getBusinessSpecificFields,
} from "../../lib/post_Call_analysis";
import { getAgentConfig } from "../../lib/AgentConfig";
import { requiresCallRecording } from "../../lib/callRecordingStates";
const STEP_FLOW = [0, 1, 3, 4, 5, 6, 7];

const getNextStepFromTracker = (tracker) => {
  const details = tracker?.details || [];

  if (!details.length) {
    return STEP_FLOW[0];
  }

  const completedStepNos = details
    .map((d) => d.stepNo)
    .filter((s) => STEP_FLOW.includes(s));

  if (!completedStepNos.length) {
    return STEP_FLOW[0];
  }

  const lastStepNo = Math.max(...completedStepNos);
  const lastIndex = STEP_FLOW.indexOf(lastStepNo);
  const nextIndex = Math.min(lastIndex + 1, STEP_FLOW.length - 1);

  return STEP_FLOW[nextIndex];
};

const getCompletedSliderStepsFromTracker = (tracker) => {
  const details = tracker?.details || [];

  const completedStepNos = Array.from(
    new Set(details.map((d) => d.stepNo).filter((s) => STEP_FLOW.includes(s)))
  );

  return completedStepNos; // stepNo == Slider index for you
};

const Step = () => {
  //  YE helper ko Step component ke andar sabse upar rakhna (useState se pehle)
  const normalizeSelected = (selected) => {
    if (!Array.isArray(selected) || !selected.length) return [];

    const first = selected[0];

    // ["url1", "url2"]
    if (typeof first === "string") {
      return selected.map((url) => ({ url, checkedStatus: true }));
    }

    // [{ url, checkedStatus }]
    if (typeof first === "object" && first !== null) {
      return selected.map((item) => ({
        url: item.url,
        checkedStatus: item.checkedStatus !== false, // default true
      }));
    }

    return [];
  };

  const [showNoGMBModal, setShowNoGMBModal] = useState(false);
  const noGMBHandlersRef = useRef({ onConfirm: null, onCancel: null });
  const timestamp = Date.now();
  const [isRoleTitleChanged, setIsRoleTitleChanged] = useState(false);
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const [currentStep, setCurrentStep] = useState(() => {
    const savedStep = sessionStorage.getItem("currentStep");
    return savedStep !== null ? parseInt(savedStep, 10) : 0;
  });
  const [selectedLang, setSelectedLang] = useState();
  const [selectedLangCode, setSelectedLangCode] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState(null);
  const [popupMessage, setPopupMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [agentCount, setAgentCount] = useState(0);
  const token = localStorage.getItem("token") || "";
  const decodeTokenData = decodeToken(token);
  const [userId, setUserId] = useState(decodeTokenData?.id || "");
  const { setHasFetched } = useDashboardStore();
  const EditingMode = localStorage.getItem("UpdationMode");
  const stepEditingMode = localStorage.getItem("UpdationModeStepWise");
  const { isLimitExceeded, CheckingUserLimit } =
    useCheckAgentCreationLimit(userId);
  const [isContinueClicked, setIsContinueClicked] = useState(false);
  const [visibleStep, setVisibleStep] = useState(0);
  const [avtarChecked, setAvtarChecked] = useState(false);
  const [completedSteps, setCompletedSteps] = useState(() => {
    const saved = sessionStorage.getItem("completedSteps");
    return saved ? JSON.parse(saved) : [];
  });
  const [customLoader, setCustomeLoader] = useState(false);
  const [isAgentCreated, setIsAgentCreated] = useState(false);
  const [isInitializingStep, setIsInitializingStep] = useState(true);

  const [reactNativeStatus, setreactNativeStatus] = useState(false);
  const [siteMapView, setSiteMapView] = useState(false);
  useEffect(() => {
    const handleNativeMessage = (event) => {
      try {
        const raw = typeof event?.data === "string" ? event.data : null;
        if (!raw) return;

        const data = JSON.parse(raw);

        if (data?.type === "IAP_STARTED") {
          // flag to skip web checkout
          window.skipCheckout = true;
        }

        if (data?.type === "IAP_SUCCESS") {
          // handle success flow...
        }

        if (data?.type === "IAP_FAILED") {
          console.warn("❌ Purchase failed", data.reason);
          // handle failure flow...
        }
      } catch (err) {
        console.error("Invalid message from app:", err);
      }
    };

    // Only attach when inside RN WebView
    if (window.ReactNativeWebView) {
      setreactNativeStatus(true);
      document.addEventListener("message", handleNativeMessage); // Android
      window.addEventListener("message", handleNativeMessage); // iOS
    }

    return () => {
      document.removeEventListener("message", handleNativeMessage);
      window.removeEventListener("message", handleNativeMessage);
    };
  }, []);

  const checkPaymentDone = localStorage.getItem("paymentDone");
  const subsID = localStorage.getItem("subcriptionIdUrl");
  const [AgentId, setAgentId] = useState();

  // Plans
  const [allPlans, setAllPlans] = useState(() => {
    const stored = localStorage.getItem("allPlans");
    return stored ? JSON.parse(stored) : [];
  });
  const [selectedPriceId, setSelectedPriceId] = useState(() => {
    return sessionStorage.getItem("priceId") || "";
  });
  const location = useLocation();

  useEffect(() => {
    if (location?.state?.mode !== "resume") {
      return;
    }
    if (!userId) return;

    const fetchTrackerAndInit = async () => {
      try {
        const email = localStorage.getItem("userEmail");

        const res = await getOnBoardingTracker({ userId, email });
        const tracker = res?.tracker;

        if (tracker) {
          const nextStep = getNextStepFromTracker(tracker);
          const completed = getCompletedSliderStepsFromTracker(tracker);

          setCompletedSteps(completed);
          setCurrentStep(nextStep);
          setVisibleStep(nextStep);
          sliderRef.current?.slickGoTo(nextStep);

          sessionStorage.setItem("currentStep", String(nextStep));
          sessionStorage.setItem("completedSteps", JSON.stringify(completed));
        }
      } catch (err) {
        console.error("Error fetching onboarding tracker:", err);
      } finally {
        // ✅ Now we know what step to show (or we failed gracefully)
        setIsInitializingStep(false);
      }
    };

    fetchTrackerAndInit();
  }, [location?.state?.mode, userId]);

  const locationPath = location?.state?.locationPath;
  const isTiered = location?.state?.plan;
  let value = location?.state?.value;
  const step1Ref = useRef(null);
  const step3Ref = useRef(null);
  const step4Ref = useRef(null);
  const step5Ref = useRef(null);
  const step6Ref = useRef(null);
  const step7Ref = useRef(null);
  const step8ARef = useRef(null);
  const step8BRef = useRef(null);
  // const step9Ref = useRef(null)
  useEffect(() => {
    if (token) {
      setUserId(decodeTokenData.id || "");
    }
  }, [token]);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const Buisness = JSON.parse(sessionStorage.getItem("businessDetails"));
  const businessType =
    Buisness?.businessType === "Other"
      ? Buisness?.customBuisness
      : Buisness?.businessType;
  const totalSlides = 8;
  const removeSpaces = (phone) => {
    if (!phone) return null;
    return phone.replace(/\s+/g, "");
  };
  const role_title =
    sessionStorage.getItem("agentRole") || "General Receptionist";
  const business =
    JSON.parse(sessionStorage.getItem("businessDetails")) ||
    "Your Business Name";
  const BusinessLocation =
    JSON.parse(sessionStorage.getItem("businessLocation")) ||
    "Your Business Services";
  const languageSelect = sessionStorage?.getItem("agentLanguage");
  const rawCustomServices =
    JSON.parse(sessionStorage.getItem("selectedCustomServices")) || [];
  const cleanedCustomServices = rawCustomServices
    .map((item) => item?.service?.trim())
    .filter(Boolean)
    .map((service) => ({ service }));

  const businessServices = business?.selectedService || [];
  const customServices = cleanedCustomServices?.map((item) =>
    typeof item === "string" ? item : item.service
  );
  const businessServiceNames = businessServices?.map((item) => item);
  const allServices = [...customServices, ...businessServiceNames];
  const commaSeparatedServices = (
    allServices?.join(", ").replace("Other", "") || "Your Business Services"
  )
    .split(",")
    .filter((service) => service.trim() !== "")
    .map((service) => `- ${service.trim()}`)
    .join("\n");
  const servicesArray = commaSeparatedServices
    .split("\n")
    .map((line) => line.replace(/^-\s*/, "").trim())
    .filter((line) => line !== "")
    .map((service) => ({ service }));
  const agentGender = sessionStorage.getItem("agentGender");
  const aboutBusinessForm =
    JSON.parse(sessionStorage.getItem("aboutBusinessForm")) ||
    "Your Business Services";
  const agentName = sessionStorage.getItem("agentName") || "";
  const packageName = sessionStorage.getItem("package") || "Free";
  const selectedServices = sessionStorage.getItem("businessDetails");
  const services = selectedServices
    ? JSON.parse(selectedServices).businessType
    : [];
  const customServicesSelected = sessionStorage.getItem("businesServices");
  const checkCustomServicesSelected = customServicesSelected?.includes("Other");
  const plan = sessionStorage.getItem("selectedPlan");
  const [shouldShowAboutBusinessNext, setShouldShowAboutBusinessNext] =
    useState(false);
  const [showThankuPage, setShowThankuPage] = useState(false);
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode");
  const shouldShowThankYou = mode === "create" || mode === "update";
  const isContinueCalled = useRef(false);
  const agentCode = sessionStorage.getItem("AgentCode");
  let freeTrail = location?.state?.freeTrial;
  const [showSiteMapUrls, setShowSiteMapUrls] = useState([]);
  const [showSiteMapModal, setShowSiteMapModal] = useState(false);
  const [addOnUrl, setAddOnUrl] = useState("");
  const [businessDetailsConfirmPopup, setBusinessDetailsConfirmPopup] =
    useState(false);
  const [businessDetails, setBusinessDetails] = useState(null);
  const [businessDetailsModalSource, setBusinessDetailsModalSource] =
    useState(null);
  const [businessDetailsConfirmed, setBusinessDetailsConfirmed] =
    useState(false);
  const [animationData, setAnimationData] = useState(null);
  const [sitemapUrls, setSitemapUrls] = useState([]);
  const [selectedSitemap, setSelectedSitemap] = useState(() => {
    try {
      const raw =
        sessionStorage.getItem("selectedSiteMapUrls") ||
        sessionStorage.getItem("selectedSiteMapUrls_backup");
      if (!raw) return [];
      return normalizeSelected(JSON.parse(raw));
    } catch (e) {
      console.error("Error initializing selectedSitemap from session", e);
      return [];
    }
  });

  const [selectedUrls, setSelectedUrls] = useState(() => {
    try {
      const raw =
        sessionStorage.getItem("selectedSiteMapUrls") ||
        sessionStorage.getItem("selectedSiteMapUrls_backup");
      if (!raw) return [];
      const parsed = normalizeSelected(JSON.parse(raw));
      return parsed.filter((i) => i.checkedStatus).map((i) => i.url);
    } catch {
      return [];
    }
  });

  const [websiteFromListing, setWebsiteFromListing] = useState("");

  const [disableLoading, setDisableLoading] = useState(false);
  const packageMap = {
    Free: 1,
    Starter: 2,
    Scaler: 3,
    Growth: 4,
    Corporate: 5,
    Enterprise: 6,
  };
  const detectRoleTypeChange = (roleTitle) => {
    setIsRoleTitleChanged((prev) => !prev);
  };
  const packageValue = packageMap[packageName] || 1;
  const addCompletedStep = (step) => {
    setCompletedSteps((prev) => {
      const updated = [...new Set([...prev, step])]; // ensure uniqueness

      return updated;
    });
  };
  const handleNext = async () => {
    if (currentStep === 3) {
      // Validate AboutBusiness form first
      if (step4Ref.current?.validate) {
        const ok = await step4Ref.current.validate();
        if (!ok) return;
      }

      // Read if "I do not have GMB" is checked
      const form = JSON.parse(
        sessionStorage.getItem("aboutBusinessForm") || "{}"
      );
      const noGoogleListing = form.noGoogleListing === true;

      // CASE 1: User said they don't have a GMB listing → Direct next step
      if (noGoogleListing) {
        if (step4Ref.current?.save) await step4Ref.current.save();

        addCompletedStep(3);
        const nextStep = 4;
        setCurrentStep(nextStep);
        setVisibleStep(nextStep);
        sliderRef.current?.slickGoTo(nextStep);
        scrollToTop();
        return;
      }

      // CASE 2: User must confirm business details
      setBusinessDetailsConfirmPopup(true);
      return;
    }

    const validations = {
      0: step1Ref,
      1: step3Ref,
      3: step4Ref,
      4: step5Ref,
      5: step6Ref,
      6: step7Ref,
      7: [step8ARef, step8BRef],
    };

    const isValid = await validation(currentStep);
    if (!isValid) return;

    const currentRef = validations[currentStep];

    if (currentRef?.current) {
      const isValid = await currentRef.current.validate?.();
      if (!isValid) return;

      if (currentRef.current.save) {
        await currentRef.current.save();
      }

      addCompletedStep(currentStep);
    }

    scrollToTop();
  };

  const handleBack = () => {
    if (currentStep > 0) {
      const prevStep = currentStep - 1 === 2 ? 1 : currentStep - 1;
      setCurrentStep(prevStep);
      setVisibleStep(prevStep);
      sliderRef.current?.slickGoTo(prevStep);
    }
  };
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    swipe: false,
    afterChange: (index) => {
      setVisibleStep(index);
    },
  };
  const fetchAgentCountFromUser = async () => {
    try {
      const response = await listAgents();
      const filterAgents = await response.filter(
        (res) => res.userId === userId
      );
      setAgentCount(filterAgents.length);
    } catch (error) {
      // console.log(error);
    }
  };
  const sanitize = (str) =>
    String(str || "")
      .trim()
      .replace(/\s+/g, "_");
  const matchedBusiness = businessTypes.find(
    (item) => item?.name === business?.businessType
  );

  const businessCode = matchedBusiness
    ? matchedBusiness.code
    : sanitize(business?.customBuisness || "oth");

  const getBusinessNameFormCustom = sessionStorage.getItem(
    "displayBusinessName"
  );
  const getBusinessNameFromGoogleListing = JSON.parse(
    sessionStorage.getItem("placeDetailsExtract")
  );
  const businessPhone = removeSpaces(getBusinessNameFromGoogleListing?.phone);
  const dynamicAgentName = `${businessCode}_${userId}_${agentCode}_#${
    agentCount + 1
  }`;
  const getLeadTypeChoices = () => {
    const fixedChoices = [
      "Spam Caller",
      "Irrelvant Call",
      "Angry Old Customer",
    ];
    const allServices = [...customServices, ...businessServiceNames];
    const cleanedServices = allServices
      .map((service) => service?.trim()) // remove extra whitespace
      .filter((service) => service && service?.toLowerCase() !== "other")
      .map((service) => {
        const normalized = service?.replace(/\s+/g, " ")?.trim();
        return `Customer for ${normalized}`;
      });
    const combinedChoices = Array.from(
      new Set([...fixedChoices, ...cleanedServices])
    );
    return combinedChoices;
  };

  ///extractPromptVariables
  function extractPromptVariables(template, dataObject) {
    const matches = [...template.matchAll(/{{(.*?)}}/g)];
    const uniqueVars = new Set(matches.map((m) => m[1].trim()));

    // Flatten dataObject to a key-value map
    const flatData = {};

    function flatten(obj) {
      for (const key in obj) {
        const val = obj[key];
        if (
          typeof val === "object" &&
          val !== null &&
          "key" in val &&
          "value" in val
        ) {
          flatData[val.key.trim()] = val.value;
        } else if (typeof val === "object" && val !== null) {
          flatten(val); // Recursively flatten nested objects
        }
      }
    }

    flatten(dataObject);

    return Array.from(uniqueVars).map((variable) => ({
      name: variable,
      value: flatData[variable] ?? null,
      status: true,
    }));
  }
  const languageAccToPlan = ["Scaler", "Growth", "Corporate"].includes(plan)
    ? "multi"
    : sessionStorage.getItem("agentLanguageCode");
  const currentState = getBusinessNameFromGoogleListing?.state || "";
  // Shared with the new onboarding flow — also matches the 2-letter state code.
  const callRecording = requiresCallRecording(
    currentState,
    getBusinessNameFromGoogleListing?.state_code
  );
  //if widget
  const ifChatWidgetEnabledOrNot =
    sessionStorage.getItem("chatWebWidget") === "true";

  const handleContinue = async () => {
    // if (step8ARef.current) {
    setIsContinueClicked(true);

    let value1 = location?.state?.value;
    if (freeTrail) {
      setCustomeLoader(true);
    }
    if (value1 === "chatke") {
      setCustomeLoader(true);
    }
    //getTimeZone
    let timeZone;
    try {
      timeZone = await getTimezoneFromState(currentState);
    } catch (err) {
      console.error(" Error fetching timezone:", err);
    }
    const agentNote = sessionStorage.getItem("agentNote");
    // const rawPromptTemplate = getAgentPrompt({
    //   industryKey:
    //     business?.businessType == "Other"
    //       ? business?.customBuisness
    //       : business?.businessType,
    //   roleTitle: sessionStorage.getItem("agentRole"),
    //   agentName: "{{AGENT NAME}}",
    //   agentGender: "{{AGENT GENDER}}",
    //   business: {
    //     businessName: "{{BUSINESS NAME}}",
    //     email: "{{BUSINESS EMAIL ID}}",
    //     aboutBusiness: "{{MORE ABOUT YOUR BUSINESS}}",
    //     address: "{{{BUSINESS ADDRESS}}",
    //   },
    //   languageSelect: "{{LANGUAGE}}",
    //   businessType: "{{BUSINESSTYPE}}",
    //   aboutBusinessForm: "{{}}",
    //   commaSeparatedServices: "{{SERVICES}}",
    //   agentNote: "{{AGENTNOTE}}",
    //   timeZone: "{{TIMEZONE}}",
    // });
    // const filledPrompt = getAgentPrompt({
    //   industryKey:
    //     business?.businessType == "Other"
    //       ? business?.customBuisness
    //       : business?.businessType, // ← dynamic from businessType
    //   roleTitle: sessionStorage.getItem("agentRole"),
    //   agentName: agentName?.split(" ")[0],
    //   agentGender: agentGender,
    //   business: {
    //     businessName:
    //       getBusinessNameFromGoogleListing?.businessName ||
    //       getBusinessNameFormCustom,
    //     email: getBusinessNameFromGoogleListing?.email || "",
    //     aboutBusiness:
    //       getBusinessNameFromGoogleListing?.aboutBusiness ||
    //       getBusinessNameFromGoogleListing?.aboutBussiness,
    //     address: getBusinessNameFromGoogleListing?.address || "",
    //   },
    //   languageSelect: languageSelect,
    //   businessType,
    //   aboutBusinessForm,
    //   commaSeparatedServices,
    //   agentNote,
    //   timeZone: timeZone?.timezoneId,
    //   languageAccToPlan,
    //   plan: plan,
    //   CallRecording: callRecording,
    // });
    // const promptVariablesList = extractPromptVariables(rawPromptTemplate, {
    //   industryKey:
    //     business?.businessType == "Other"
    //       ? business?.customBuisness
    //       : business?.businessType,
    //   roleTitle: sessionStorage.getItem("agentRole"),
    //   agentName: { key: "AGENT NAME", value: agentName?.split(" ")[0] },
    //   agentGender: { key: "AGENT GENDER", value: agentGender },
    //   business: {
    //     businessName: {
    //       key: "BUSINESS NAME",
    //       value:
    //         getBusinessNameFromGoogleListing?.businessName ||
    //         getBusinessNameFormCustom,
    //     },
    //     email: {
    //       key: "BUSINESS EMAIL ID",
    //       value: getBusinessNameFromGoogleListing?.email || "",
    //     },
    //     aboutBusiness: {
    //       key: "MORE ABOUT YOUR BUSINESS",
    //       value:
    //         getBusinessNameFromGoogleListing?.aboutBusiness ||
    //         getBusinessNameFromGoogleListing?.aboutBussiness,
    //     },
    //     address: {
    //       key: "BUSINESS ADDRESS",
    //       value: getBusinessNameFromGoogleListing?.address || "",
    //     },
    //   },
    //   languageSelect: { key: "LANGUAGE", value: languageSelect || "" },
    //   businessType: { key: "BUSINESSTYPE", value: businessType || "" },
    //   commaSeparatedServices: { key: "SERVICES", value: servicesArray || "" },
    //   timeZone: { key: "TIMEZONE", value: timeZone?.timezoneId || "" },
    // });
    const promptConfig = {
  industryKey:
    business?.businessType === "Other"
      ? business?.customBuisness
      : business?.businessType,
  roleTitle: sessionStorage.getItem("agentRole"),
  agentName: agentName?.split(" ")[0],
  agentGender,
  business: {
    businessName:
      getBusinessNameFromGoogleListing?.businessName ||
      getBusinessNameFormCustom,
    email: getBusinessNameFromGoogleListing?.email || "",
    aboutBusiness:
      getBusinessNameFromGoogleListing?.aboutBusiness ||
      getBusinessNameFromGoogleListing?.aboutBussiness || "",
    address: getBusinessNameFromGoogleListing?.address || "",
  },
  languageSelect,
  businessType,
  aboutBusinessForm,
  commaSeparatedServices,
  servicesArray,
  agentNote,
  timeZone: timeZone?.timezoneId,
  languageAccToPlan,
  plan,
  callRecording,
};

    // const isValid = step8BRef.current.validate()
    //creation here
    if (localStorage.getItem("UpdationMode") != "ON") {
      setLoading(true);
      const agentConfig = {
        version: 0,
        model: "gemini-2.0-flash",
        model_temperature: 0,
        model_high_priority: true,
        tool_call_strict_mode: true,
        general_prompt: "",
        general_tools: [
          {
            type: "end_call",
            name: "end_call",
            description: "End the call with user.",
          },
          {
            type: "extract_dynamic_variable",
            name: "extract_user_details",
            description:
              "Extract the user's details like name, email, phone number, address, and reason for calling from the conversation",
            variables: [
              {
                type: "string",
                name: "email",
                description:
                  "Extract the user's email address from the conversation",
              },
              {
                type: "number",
                name: "phone",
                description:
                  "Extract the user's phone number from the conversation",
              },
              {
                type: "string",
                name: "address",
                description: "Extract the user's address from the conversation",
              },
              {
                type: "string",
                name: "reason",
                description:
                  "Extract the user's reason for calling from the conversation",
              },
              {
                type: "string",
                name: "name",
                description: "Extract the user's name from the conversation\"",
              },
            ],
          },
          {
            name: "get_conversation_history",
            description:
              "Fetch previous coversation history by customer email address",
            type: "custom",
            method: "POST",
            url: `${process.env.REACT_APP_API_BASE_URL}/Chatbot/get_chat_logs?email={{parameter.email}}`,
            // url: `https://a0c3-223-178-211-123.ngrok-free.app/Chatbot/get_chat_logs?email={{parameter.email}}`,
            // url: `https://9280a12eb35e.ngrok-free.app/Chatbot/get_chat_logs?email={{parameter.email}}`,

            speak_after_execution: true,

            // Query parameters for GET request
            query_params: {
              email: "{{parameter.email}}",
            },

            // Response variables to extract order status
            parameters: {
              type: "object",
              properties: {
                email: {
                  type: "string",
                  description:
                    "Customer email address to fetch conversation history",
                },
              },
              required: ["email"],
            },
          },
          {
            name: "book_calendar_event",
            description:
              "Create a Google Calendar meeting with details such as title, description, timing, attendees, and reminders.",
            type: "custom",
            method: "POST",
            url: `${API_BASE_URL}/create-meeting`,
            // url: `https://a0c3-223-178-211-123.ngrok-free.app/api/create-meeting`,
            // url: `https://9280a12eb35e.-free.app/api/create-meeting`,

            speak_after_execution: true,

            // Body parameters (payload sent in the request)
            body: {
              email: "{{parameter.userId}}",
              name: "{{parameter.name}}",
              userId: "{{parameter.userId}}",
            },

            // Parameter schema for chatbot input validation
            parameters: {
              type: "object",
              properties: {
                userId: {
                  type: "string",
                  description:
                    "Unique user identifier dynamically retrieved from retell_llm_dynamic_variables (e.g., context.retell_llm_dynamic_variables.userId). ",
                },
                title: {
                  type: "string",
                  description: "Title of the calendar event",
                },
                description: {
                  type: "string",
                  description: "Details or agenda of the event",
                },
                start: {
                  type: "string",
                  description:
                    "Event start datetime in ISO format (e.g. 2025-10-27T15:00:00+05:30)",
                },
                end: {
                  type: "string",
                  description:
                    "Event end datetime in ISO format (e.g. 2025-10-27T16:00:00+05:30)",
                },
                timezone: {
                  type: "string",
                  description: "Timezone for the event (default: UTC)",
                  default: "UTC",
                },
                attendees: {
                  type: "array",
                  items: {
                    type: "object",
                    properties: {
                      email: { type: "string" },
                      displayName: { type: "string" },
                    },
                  },
                  description:
                    "List of attendee email addresses and display names",
                },
                location: {
                  type: "string",
                  description: "Location or meeting link of the event",
                },
                conference: {
                  type: "boolean",
                  description:
                    "Whether to create a Google Meet link automatically (default: true)",
                  default: true,
                },
                reminders: {
                  type: "object",
                  properties: {
                    email: {
                      type: "number",
                      description:
                        "Minutes before event to send email reminder",
                    },
                    popup: {
                      type: "number",
                      description:
                        "Minutes before event to show popup reminder",
                    },
                  },
                },
                sendUpdates: {
                  type: "string",
                  enum: ["all", "externalOnly", "none"],
                  description:
                    "Who should receive updates when event changes (default: all)",
                  default: "all",
                },
                idempotencyKey: {
                  type: "string",
                  description: "Unique key to prevent duplicate event creation",
                },
                calendarId: {
                  type: "string",
                  description: "Google Calendar ID (default: primary)",
                  default: "primary",
                },
              },
              required: ["title", "start", "end", "userId"],
            },
          },
          ...getAgentConfig(businessType),
        ],
        states: [
          {
            name: "information_collection",
            state_prompt: `Greet the user with the begin_message and assist with their query.

                               If the user sounds dissatisfied (angry, frustrated, upset) or uses negative words (like "bad service", "unhappy", "terrible","waste of time"),
                               ask them: "I'm sorry to hear that. Could you please tell me about your concern?"
                               Analyze their response. 
                               
                                If the concern contains **spam, irrelevant or abusive content**
                                (e.g., random questions, profanity, jokes), say:
                                "I’m here to assist with service-related concerns. Could you please share your issue regarding our service?"
                                and stay in this state.

                                If the concern is **service-related** or **business** (e.g., staff, delay, poor support),
                                transition to dissatisfaction_confirmation.

                                If the user asks for an appointment (e.g., "appointment", "book", "schedule"),
                                transition to appointment_booking.

                                If the user is silent or unclear, say: "Sorry, I didn’t catch that. Could you please repeat?"
                                If the user wants to end the call transition to end_call_state`,
            edges: [
              {
                destination_state_name: "dissatisfaction_confirmation",
                description: "User sounds angry or expresses dissatisfaction.",
              },
            ],
          },
          {
            name: "appointment_booking",
            state_prompt: `First, call the check_availability tool to verify if the calendar is connected.
                           - If calendar is connected and slots are returned:
                            - Ask the user for preferred date and time.
                            - Ask what service they’re interested in.
                            - Once you have both, confirm the details.
                            - Then call book_appointment_cal to schedule.
                        
                            If booking fails:
                            - Say: "Our scheduling system is busy right now. I’ve saved your details, and a team member will call you within 24 hours to confirm your appointment."

                            - Then, ask: "Do you have any other queries?"
                        
                            - If yes, transition to information_collection.
                           
                        
                        - If check_availability fails or no slots are returned:
                            - Say: "Our booking system is currently unavailable for direct scheduling. I’ll collect your details and a team member will reach out within 24 hours to confirm your appointment."
                            - Collect: name, phone number, email, and purpose.
                            - Then say: "Thanks! We’ll get back to you shortly."
                            - Then ask: "Do you have any other queries?"
                            - If yes, transition to information_collection.
                            
                        `,
            tools: [],
            edges: [
              {
                destination_state_name: "information_collection",
                description:
                  "User has further queries or provides new information after booking.",
              },
            ],
          },

          // 🌟 State: Dissatisfaction Confirmation
          {
            name: "dissatisfaction_confirmation",
            state_prompt: `
                            Say: "I'm sorry you're not satisfied. Would you like me to connect you to a team member? Please say yes or no."
                            Wait for their response.

                            If the user says yes, transition to call_transfer.
                            If the user says no, transition to end_call_state.
                            If the response is unclear, repeat the question once.
                        `,
            edges: [
              {
                destination_state_name: "call_transfer",
                description: "User agreed to speak to team member.",
              },
              {
                destination_state_name: "end_call_state",
                description: "User declined to speak to team member.",
              },
            ],
            tools: [],
          },

          // 🌟 State: Call Transfer
          {
            name: "call_transfer",
            state_prompt: `
                            Connecting you to a team member now. Please hold.
                        `,
            tools: [
              {
                type: "transfer_call",
                name: "transfer_to_team",
                description: "Transfer the call to the team member.",
                transfer_destination: {
                  type: "predefined",
                  number: "{{business_Phone}}",
                },
                transfer_option: {
                  type: "cold_transfer",
                  public_handoff_option: {
                    message: "Please hold while I transfer your call.",
                  },
                },
                speak_during_execution: true,
                speak_after_execution: true,
                failure_message:
                  "Sorry, I couldn't transfer your call. Please contact us at {{business_email}} or call {{business_Phone}} directly.",
              },
            ],
            edges: [],
          },
          {
            name: "end_call_state",
            state_prompt: `
                            Politely end the call by saying: "Thank you for calling. Have a great day!"
                        `,
            tools: [
              {
                type: "end_call",
                name: "end_call1",
                description: "End the call with the user.",
              },
            ],
            edges: [],
          },
        ],
        starting_state: "information_collection",
        default_dynamic_variables: {
          customer_name: "John Doe",
          business_Phone: businessPhone || "",
          business_email: business.email,
          timeZone: timeZone?.timezoneId,
          customer_phone: "{{customer_phone}}",
          known_caller: "false",
          caller_name: "",
        },
      };
      const knowledgeBaseId = sessionStorage.getItem("knowledgeBaseId");
      if (knowledgeBaseId) {
        agentConfig.knowledge_base_ids = [knowledgeBaseId];
      }
      // const llmResponse = await createLlmWithKnowledgBaseId(token, agentConfig);
        const llmResponse = await createLlmWithKnowledgBaseId(token, {
        llmConfig: agentConfig,   // general_prompt के बिना
        promptConfig,
      });  
      //Create LLm
      const { filledPrompt, rawPromptTemplate, promptVariablesList } =  llmResponse?.data?.promptData;
      // console.log("Filled Prompt:", filledPrompt);
      // console.log("Raw Prompt Template:", rawPromptTemplate);
      // console.log("Prompt Variables List:", promptVariablesList);
    
      try {
        sessionStorage.setItem("llmId", llmResponse?.data?.data?.llm_id);
        const llmId = llmResponse?.data?.data?.llm_id;
        const response_engine = {
          type: "retell-llm",
          llm_id: llmId,
        };
        const finalAgentData = {
          response_engine,
          voice_id: sessionStorage.getItem("agentVoice") || "11labs-Adrian",
          language: sessionStorage.getItem("agentLanguageCode") || "en-US",
          agent_name: dynamicAgentName || sessionStorage.getItem("agentName"),
          language: languageAccToPlan,
          post_call_analysis_model: "gpt-4o-mini",
          responsiveness: 1,
          enable_backchannel: true,
          interruption_sensitivity: 0.91,
          backchannel_frequency: 0.7,
          backchannel_words: [
            "Got it",
            "Yeah",
            "Uh-huh",
            "Understand",
            "Ok",
            "hmmm",
          ],
          post_call_analysis_data: [
            {
              type: "enum",
              name: "lead_type",
              description: "Feedback given by the customer about the call.",
              choices: getLeadTypeChoices(),
            },
            {
              type: "string",
              name: "name",
              description: "Extract the user's name from the conversation",
              examples: [
                "Ajay Sood",
                "John Wick",
                "Adam Zampa",
                "Jane Doe",
                "Nitish Kumar",
                "Ravi Shukla",
              ],
            },
            {
              type: "string",
              name: "email",
              description: "Extract the user's email from the conversation",
              examples: [
                "john.doe@example.com",
                "nitish@company.in",
                "12@gmail.com",
              ],
            },
            {
              type: "string",
              name: "reason",
              description:
                "The reason the user is calling or their inquiry. If provided in Hindi, translate to English. Summarize if it's long.",
              examples: [
                "Schedule an appointment",
                "Ask about services",
                "Request for accounting help",
              ],
            },
            {
              type: "string",
              name: "address",
              description:
                "Extract the user's personal address from the conversation. If the user explicitly provides their own address, include and format it for CRM or contact forms. If no personal address is mentioned, do not add or infer any business location. If the address is spoken in Hindi, translate it to English before returning.",
              examples: [
                "123 Main St, Delhi",
                "42 Wallaby Way, Sydney",
                "1490 Aandhar Eleven",
              ],
            },
            {
              type: "number",
              name: "phone_number",
              description:
                "The user's phone number in numeric format. If digits are spoken in words (e.g., 'seven eight seven six one two'), convert them to digits (e.g., '787612'). Ensure it's a valid number when possible.",
            },

            ...appointmentBooking(businessType),
            ...getBusinessSpecificFields(businessType),
          ],
          end_call_after_silence_ms: 30000,
          normalize_for_speech: true,
          ambient_sound: "call-center",
          ring_duration_ms: 15000,
          ambient_sound_volume: 1,
          webhook_url: `${API_BASE_URL}/agent/updateAgentCall_And_Mins_WebHook`,
          // webhook_url: `https://a0c3-223-178-211-123.ngrok-free.app/api/agent/updateAgentCall_And_Mins_WebHook`,
        };
        // Create Agent Creation
        try {
          const response = await createAgentWithLlmAndKnowledgeBaseId(
            token,
            finalAgentData
          );
          const agentId = response?.data?.data?.agent_id;
          setAgentId(agentId);
          // Get businessId from sessionStorage
          const businessIdString =
            sessionStorage.getItem("businessId") || '{"businessId":1}';
          // Convert string to object
          const businessIdObj = JSON.parse(businessIdString);
          // Now access the actual ID
          const agentData = {
            userId: userId,
            agent_id: agentId || sessionStorage.getItem("agentId"),
            knowledgeBaseId: sessionStorage.getItem("knowledgeBaseId"),
            llmId: sessionStorage.getItem("llmId"),
            avatar: sessionStorage.getItem("avatar") || "",
            agentVoice: sessionStorage.getItem("agentVoice") || "11labs-Adrian",
            agentAccent:
              sessionStorage.getItem("agentVoiceAccent") || "American",
            agentRole:
              sessionStorage.getItem("agentRole") || "Genral Receptionist",
            agentName: sessionStorage.getItem("agentName") || "",
            agentLanguageCode:
              sessionStorage.getItem("agentLanguageCode") || "en-US",
            agentLanguage:
              sessionStorage.getItem("agentLanguage") || "English (US)",
            agentGender: sessionStorage.getItem("agentGender") || "female",
            agentPlan: "free" || "Plus",
            agentStatus: true,
            businessId: businessIdObj.businessId,
            responsiveness: 1,
            enable_backchannel: true,
            interruption_sensitivity: 0.7,
            backchannel_frequency: 0.7,
            backchannel_words: [
              "Got it",
              "Yeah",
              "Uh-huh",
              "Understand",
              "Ok",
              "hmmm",
            ],
            additionalNote: agentNote || "",
            agentCode,
            knowledgeBaseStatus: true,
            end_call_after_silence_ms: 30000,
            dynamicPromptTemplate: filledPrompt,
            rawPromptTemplate: rawPromptTemplate,
            post_call_analysis_data: [
              {
                type: "enum",
                name: "lead_type",
                description: "Feedback given by the customer about the call.",
                choices: getLeadTypeChoices(),
              },
              {
                type: "string",
                name: "name",
                description: "Extract the user's name from the conversation",
                examples: [
                  "Ajay Sood",
                  "John Wick",
                  "Adam Zampa",
                  "Jane Doe",
                  "Nitish Kumar",
                  "Ravi Shukla",
                ],
              },
              {
                type: "string",
                name: "email",
                description: "Extract the user's email from the conversation",
                examples: [
                  "john.doe@example.com",
                  "nitish@company.in",
                  "12@gmail.com",
                ],
              },
              {
                type: "string",
                name: "reason",
                description:
                  "The reason the user is calling or their inquiry. If provided in Hindi, translate to English. Summarize if it's long.",
                examples: [
                  "Schedule an appointment",
                  "Ask about services",
                  "Request for accounting help",
                ],
              },
              {
                type: "string",
                name: "address",
                description:
                  "The user's address or business location. If spoken in Hindi, translate to English. Format it for use in CRM or contact forms.",
                examples: [
                  "123 Main St, Delhi",
                  "42 Wallaby Way, Sydney",
                  "1490 Aandhar Eleven",
                ],
              },
              {
                type: "number",
                name: "phone_number",
                description:
                  "The user's phone number in numeric format. If digits are spoken in words (e.g., 'seven eight seven six one two'), convert them to digits (e.g., '787612'). Ensure it's a valid number when possible.",
              },
              {
                type: "boolean",
                name: "appointment_booked",
                description:
                  "Determine if appointment was successfully booked during the call and also if you get appointment deatails like email and date then only mark true",
                examples: [true, false],
              },
              {
                type: "string",
                name: "appointment_date",
                description:
                  "Extract the exact appointment date mentioned by customer. Format: YYYY-MM-DD",
                examples: ["2025-01-15", "2025-02-20", "2025-03-10"],
              },
              {
                type: "string",
                name: "appointment_time",
                description:
                  "Extract the exact appointment time mentioned by customer. Format: HH:MM AM/PM",
                examples: ["10:00 AM", "2:30 PM", "9:15 AM"],
              },
              {
                type: "string",
                name: "appointment_timezone",
                description:
                  "Extract timezone if mentioned, otherwise use default. Format: America/Los_Angeles style",
                examples: ["America/Los_Angeles", "America/New_York", "UTC"],
              },
              ...getBusinessSpecificFields(businessType),
            ],
            promptVariablesList: JSON.stringify(promptVariablesList),
            CallRecording: callRecording,
            voiceWidgetEnabled: true,
            timezone: timeZone?.timezoneId || "",
          };
          try {
            const response = await createAgent(agentData);

            if (response.status === 200 || response.status === 201) {
              const selectedNumber = sessionStorage.setItem(
                "agentId",
                response.data.agent_id
              );
              sessionStorage.setItem("agentStatus", true);
              sessionStorage.removeItem("avatar");
              setPopupType("success");
              await updateAgentWidgetDomain(
                agentId,
                aboutBusinessForm?.businessUrl
              );
              //AssignNumber both Agent
              const assignedNumber = sessionStorage.getItem(
                "assignedPhoneNumber"
              );

              // if (assignedNumber) {
              //   if (!plan == "free" && plan !== null) {

              //     await assignNumberToAgent(
              //       assignedNumber,
              //       response.data.agent_id
              //     );
              //   }
              // }
              // if (assignedNumber) {
              //   await assignNumberToAgent(assignedNumber, response.data.agent_id)
              // }
              if (ifChatWidgetEnabledOrNot) {
                // alert("ok")
                // Shared payload data for both Voice Agent and Chat Agent
                const commonAgentPayload = {
                  industryKey:
                    business?.businessType == "Other"
                      ? business?.customBuisness
                      : business?.businessType,
                  roleTitle: sessionStorage.getItem("agentRole"),
                  agentName: agentName?.split(" ")[0],
                  agentGender: agentGender,
                  business: {
                    businessName:
                      getBusinessNameFromGoogleListing?.businessName ||
                      getBusinessNameFormCustom,
                    email: getBusinessNameFromGoogleListing?.email || "",
                    aboutBusiness:
                      getBusinessNameFromGoogleListing?.aboutBusiness ||
                      getBusinessNameFromGoogleListing?.aboutBussiness,
                    address: getBusinessNameFromGoogleListing?.address || "",
                  },
                  languageSelect: languageSelect,
                  businessType,
                  aboutBusinessForm,
                  allServices,
                  agentNote,
                  timeZone: timeZone?.timezoneId,
                  languageAccToPlan,
                  plan: plan,
                  CallRecording: callRecording,
                  knowledgeBaseId: sessionStorage.getItem("knowledgeBaseId"),
                  businessPhone,
                  businessEmail: business?.email,
                  agent_id: agentId || sessionStorage.getItem("agentId"),
                };
                const response = await createChatAgent(
                  commonAgentPayload,
                  token
                );
              }
              // if (checkPaymentDone === "true") {
              //     await callNextApiAndRedirect(agentId)
              // }

              setPopupMessage("Agent created successfully!");
              setIsAgentCreated(true);
              setShowPopup(true);
              if (freeTrail) {
                setCustomeLoader(true);
                setTimeout(
                  () => navigate("/fast-agent-detail", { replace: true }),
                  2000
                );
              }
              // else if (value1 === "chatke") {
              //   setCustomeLoader(true);
              //   setTimeout(
              //     () => navigate("/fast-agent-detail", { replace: true }),
              //     2000
              //   );
              // }
              else if (isUser === "true") {
                setCustomeLoader(true);
                setTimeout(
                  () => navigate("/fast-agent-detail", { replace: true }),
                  2000
                );
              }
              if (checkPaymentDone === "true") {
                setCustomeLoader(true);
                setTimeout(
                  () => navigate("/fast-agent-detail", { replace: true }),
                  2000
                );
              }

              setHasFetched(false);
              setLoading(false);
              // sessionStorage.clear()
            }
          } catch (error) {
            if (error?.status == 400) {
              setIsAgentCreated(false);
              setPopupType("failed");
              setPopupMessage(error?.response?.data?.message);
              setShowPopup(true);
              setLoading(false);
            } else {
              console.error("Agent creation failed:", error);
              setPopupType("failed");
              setPopupMessage(
                "Agent creation failed while saving data in Database. Please try again."
              );
              setShowPopup(true);
              setLoading(false);
              setIsAgentCreated(false);
            }
          }
        } catch (err) {
          console.error("Upload failed:", err);
          setPopupType("failed");
          setPopupMessage("Agent creation failed.");
          setShowPopup(true);
          setLoading(false);
        }
      } catch (error) {
        console.error("LLM creation failed:", error);
        setPopupType("failed");
        setPopupMessage("LLM creation failed. Please try again.");
        setShowPopup(true);
        setLoading(false);
      }
      setLoading(false);
    }
  };
  const handleValidationError = ({ type, message }) => {
    setPopupType(type);
    setPopupMessage(message);
    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
    }, 3000);
  };
  const getStepTitle = () => {
    const steps = {
      0: {
        title: EditingMode ? "Edit: Business Type" : "Business Type",
        subTitle: "Select category which best describes your business type",
        // icon: "business-type-icon.svg",
        tooltip: <Tooltip />,
      },
      1: {
        title: EditingMode ? "Edit: Services Offered" : "Services Offered",
        subTitle: "Select the “Services You Offer” for your Business",
        // icon: "services-icon.svg",
        tooltip: <Tooltip />,
      },
      3: {
        title: EditingMode ? "Edit: Find Your Business" : "Find Your Business",
        subTitle: "Enter your Business name to find Google Business Listing",
        // icon: "listing-icon.svg",
        tooltip: <Tooltip />,
      },
      4: {
        title: EditingMode ? "Edit: Business Details" : "Business Details",
        subTitle:
          "Verify or Update your Business Details we got from your public listings",
        // icon: "details-icon.svg",
        tooltip: <Tooltip />,
      },
      5: {
        title: EditingMode ? "Edit: Select Language" : "Select Language",
        subTitle: "Select the Primary Language, You want your agent to speak",
        // icon: "language-icon.svg",
        tooltip: <Tooltip />,
      },
      6: {
        title: EditingMode ? "Edit: Select Voice" : "Select Voice",
        subTitle: "Select a voice for your agent as per your liking",
        // icon: "voice-icon.svg",
        tooltip: <Tooltip />,
      },
      7: {
        title: EditingMode ? "Edit: Name & Avatar" : "Name & Avatar",
        subTitle: "Select your AI receptionist for your Business",
        // icon: "gender-icon.svg",
        tooltip: <Tooltip />,
      },
    };

    return (
      steps[currentStep] || {
        title: "Step Not Found",
        subTitle: "",
        icon: "default-icon.svg",
      }
    );
  };
  useEffect(() => {
    if (!CheckingUserLimit && isLimitExceeded && !EditingMode) {
      setShowPopup(true);
      setPopupType("failed");
      setPopupMessage(
        "Agent creation limit exceeded. Please upgrade your plan!"
      );
    }
  }, [CheckingUserLimit, isLimitExceeded]);

  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const validation = async (currentStep) => {
    const validations = {
      0: step1Ref,
      1: step3Ref,
      3: step4Ref,
      4: step5Ref,
      5: step6Ref,
      6: step7Ref,
      7: [step8ARef, step8BRef],
    };

    const refs = validations[currentStep];

    if (Array.isArray(refs)) {
      for (let ref of refs) {
        if (ref?.current?.validate) {
          const isValid = await ref.current.validate();
          if (!isValid) return false;

          if (ref?.current?.save) {
            await ref.current.save();
          }
        }
      }
    } else {
      if (refs?.current?.validate) {
        const isValid = await refs.current.validate();
        if (!isValid) return false;

        if (refs?.current?.save) {
          await refs.current.save();
        }
      }
    }

    addCompletedStep(currentStep);
    return true;
  };
  // function lock
  useEffect(() => {
    fetchAgentCountFromUser();
  }, []);

  useEffect(() => {
    if (location?.state?.mode === "resume") return;

    const savedStep = sessionStorage.getItem("currentStep");
    if (savedStep !== null) {
      const parsedStep = parseInt(savedStep, 10);
      setCurrentStep(parsedStep);
      sliderRef.current?.slickGoTo(parsedStep);
    }

    setIsInitializingStep(false);
  }, [location?.state?.mode]);

  useEffect(() => {
    sessionStorage.setItem("currentStep", currentStep.toString());
  }, [currentStep]);
  useEffect(() => {
    sessionStorage.setItem("completedSteps", JSON.stringify(completedSteps));
  }, [completedSteps]);
  let isUser = sessionStorage.getItem("isUser");
  const tierCheckout = async () => {
    try {
      const res = await axios.post(`${API_BASE_URL}/tier/checkout`, {
        customerId: decodeTokenData?.customerId,
        presetUnits: location?.state?.value,
        minUnits: 0,
        maxUnits: 200,
        successUrl:
          window.location.origin +
          `/steps?mode=create&userId=${decodeTokenData?.id}`, // origin + path
        cancelUrl: window.location.origin + "/cancel-payment",
        userId: decodeTokenData?.id,
      });

      if (res?.data?.url) {
        window.location.href = res.data.url; // redirect user
      }
    } catch (error) {
      console.error("Checkout error:", error);
    }
  };

  const handleSubmit = () => {
    let priceId = sessionStorage.getItem("priceId");
    let freeTrail = location?.state?.value;

    if (freeTrail === "chatke" || isUser === "true") {
      handleContinue();
      // sessionStorage.removeItem(isUser)
    } else if (checkPaymentDone === "true") {
      // callNextApiAndRedirect()
      handleContinue();
    } else if (locationPath !== "/checkout" && priceId) {
      if (currentStep === 7) {
        const isStep3Valid = step8ARef.current?.validate?.();
        const isStep4Valid = step8BRef.current?.validate?.();
        if (!isStep3Valid || !isStep4Valid) return;
        handleBuyPlan({
          priceId: priceId,
          planName: plan,
          interval: sessionStorage.getItem("selectedPlanInterval"),
        });
        if (reactNativeStatus) {
          // console.log(
          //   "Skipping web checkout because native IAP is in progress"
          // );
        } else {
          navigate("/checkout");
        }
      }
    } else if (isTiered === "tierPlan") {
      tierCheckout();
    } else if (locationPath !== "/checkout" && !priceId) {
      if (currentStep === 7) {
        const isStep3Valid = step8ARef.current?.validate?.();
        const isStep4Valid = step8BRef.current?.validate?.();
        if (!isStep3Valid || !isStep4Valid) return;
        navigate("/plans");
        addCompletedStep(currentStep);
      }
    } else if (locationPath !== "/checkout" && !priceId) {
      if (currentStep === 7) {
        const isStep3Valid = step8ARef.current?.validate?.();
        const isStep4Valid = step8BRef.current?.validate?.();
        if (!isStep3Valid || !isStep4Valid) return;
        navigate("/plans");
        addCompletedStep(currentStep);
      }
    }
  };

  useEffect(() => {
    if (freeTrail && currentStep === 7 && !isContinueCalled.current) {
      handleContinue();
      isContinueCalled.current = true;
    } else if (
      locationPath === "/checkout" &&
      currentStep === 7 &&
      !isContinueCalled.current
    ) {
      // handleContinue();
      isContinueCalled.current = true;
    }
  }, [freeTrail, currentStep, locationPath]);
  const step = getStepTitle();
  useEffect(() => {
    const storedValue = sessionStorage?.getItem("avtarChecked");
    if (storedValue !== null) {
      setAvtarChecked(JSON?.parse(storedValue));
    }
  }, []);
  const tooltipContentMap = {
    0: (
      <>
        <strong
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "1rem",
            marginBottom: "15px",
          }}
        >
          {" "}
          Tell Us About Your Business
        </strong>
        <br></br>
        <br></br>
        <p>
          To ensure you get the most relevant output from your Virtual
          Receptionist, please tell us a little about your business. This
          information helps us personalize your experience and recommend
          features that best fit your specific needs.
        </p>
        <br></br>
        <ul>
          <li>
            <strong>1. What best describes your Business Category?</strong>
          </li>
          <p>Example: Retail, Hospitality, Healthcare, Services, Technology</p>
          <br></br>
        </ul>
      </>
    ),
    1: (
      <>
        <p>
          {" "}
          Please select the services your business provides. Knowing your
          service offerings helps us recommend the best features for your
          Virtual Receptionist and personalize your experience. Don't see your
          service? Just click "Add More Services."
        </p>
        <br></br>
        <ul>
          <li>
            <strong>Example:</strong> For a restaurant, you might select
            services like "Table Reservations," "Takeout Orders," and "Menu
            Inquiries."
          </li>
        </ul>
      </>
    ),
    3: (
      <>
        <strong
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "1rem",
            marginBottom: "15px",
          }}
        >
          {" "}
          Enhance Your Voice Agent's Knowledge
        </strong>
        <br></br>
        <br></br>
        <p>
          Please add your Google My Business URL and website link. These public
          listings help us deeply understand your business, allowing us to build
          a smart knowledge base for your Virtual Receptionist, so it can answer
          customer questions accurately.
        </p>
        <br></br>

        <li>
          <strong>Google My Business:</strong> Simply type your business name
          and select it from the results shown.
        </li>

        <br></br>
        <p>
          If you don't have a Google My Business listing or a website, simply
          click "My business name is not listed here."
        </p>
      </>
    ),
    4: (
      <>
        <strong
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "1rem",
            marginBottom: "15px",
          }}
        >
          {" "}
          Review Your Business Information
        </strong>
        <br></br>
        <br></br>
        <p>
          This screen provides a centralized view of your essential business
          details: your Business URL, Name, Address, Phone Number, and Email,
          along with a space for your Business Description.
        </p>
        <br></br>
        <ol>
          <li>
            We've either pre-filled this information directly from your Google
            My Business listing, or if you don't have one, these fields will be
            ready for your input.
          </li>
          <li>
            You have the flexibility to add or edit any of these fields as
            needed.
          </li>
          <li>
            Please ensure these details are current and correct. Accurate
            information helps your Virtual Receptionist agent provide precise
            answers and ensures your customers can easily connect with you.
          </li>
          <li>
            Don't worry if you don't have everything ready! Your Business Email
            and "About your business" description are optional and can be
            completed at your convenience.
          </li>
        </ol>
      </>
    ),
    5: "This is the main language your agent will use for all its interactions. Choosing the correct language ensures the best communication experience. We Support 25+ Languages.",
    6: "Select the avtar you prefer for your AI agent, then listen to the available voice options to pick the one that best represents your business.",
    7: "Pick an avatar for your agent, feel free to edit their name, and then decide their core function by selecting an agent type – either a helpful General Receptionist or an efficient Inbound Lead Qualifier.",
  };
  const hanldeAgentCreation = async () => {
    handleContinue();
  };
  const handleSelectAll = () => {
    let updated;

    updated = [...showSiteMapUrls];
    setSelectedUrls(updated);
    const updatedWithStatus = showSiteMapUrls.map((item) => ({
      url: item,
      checkedStatus: updated.includes(item),
    }));

    sessionStorage.setItem(
      "selectedSiteMapUrls",
      JSON.stringify(updatedWithStatus)
    );
  };
  const handleBusinessDetailsPopup = (details) => {
    setBusinessDetails(details);
    setBusinessDetailsModalSource("select");
    setBusinessDetailsConfirmPopup(true);
    setBusinessDetailsConfirmed(false);
  };

  //handleIsSiteMapView

  const handleIsSiteMapView = (data) => {
    const urls = data?.urls || [];
    const preSelected = normalizeSelected(data?.selected || []);
    let savedSelected = [];
    try {
      const raw =
        sessionStorage.getItem("selectedSiteMapUrls_backup") ||
        sessionStorage.getItem("selectedSiteMapUrls");

      savedSelected = raw ? normalizeSelected(JSON.parse(raw)) : [];
    } catch {
      savedSelected = [];
    }

    const effectiveSelected =
      preSelected.length > 0 ? preSelected : savedSelected;

    setSitemapUrls(urls);
    setWebsiteFromListing(data?.addOnUrl || "");

    // ✅ merge selection with current urls list
    const map = new Map(effectiveSelected.map((i) => [i.url, i.checkedStatus]));
    let merged = urls.map((u) => ({
      url: u,
      checkedStatus: map.get(u) ?? false,
    }));

    // keep items not present in current urls
    effectiveSelected.forEach((i) => {
      if (!urls.includes(i.url)) merged.push(i);
    });

    // ✅ If STILL nothing checked anywhere → then ONLY default 10
    const anyChecked = merged.some((i) => i.checkedStatus);

    if (!anyChecked) {
      const DEFAULT_LIMIT = 10;
      merged = urls.map((u, idx) => ({
        url: u,
        checkedStatus: idx < DEFAULT_LIMIT,
      }));

      // ✅ save default only once
      sessionStorage.setItem("selectedSiteMapUrls", JSON.stringify(merged));
      sessionStorage.setItem(
        "selectedSiteMapUrls_backup",
        JSON.stringify(merged)
      );
    }

    setSelectedSitemap(merged);
    setSelectedUrls(merged.filter((i) => i.checkedStatus).map((i) => i.url));
    setSiteMapView(true);
  };

  const handleConfirmSitemap = () => {
    const checkedCount = selectedSitemap.filter((i) => i.checkedStatus).length;

    if (checkedCount > 100) {
      setShowPopup(true);
      setPopupType("failed");
      setPopupMessage("You can select only 100 URLs.");
      return;
    }

    sessionStorage.setItem(
      "selectedSiteMapUrls",
      JSON.stringify(selectedSitemap)
    );
    sessionStorage.setItem(
      "selectedSiteMapUrls_backup",
      JSON.stringify(selectedSitemap)
    );

    setSelectedUrls(
      selectedSitemap.filter((i) => i.checkedStatus).map((i) => i.url)
    );
    setSiteMapView(false);
    window.dispatchEvent(new Event("sitemapSelectionUpdated"));
  };

  const handleSiteMapUrlsCheckbox = (page) => {
    const MAX_LIMIT = 100;

    let updatedSelection = [...selectedSitemap];

    const index = updatedSelection.findIndex((item) => item.url === page);

    const checkedCount = updatedSelection.filter(
      (item) => item.checkedStatus
    ).length;

    if (index !== -1) {
      const isCurrentlyChecked = updatedSelection[index].checkedStatus;
      if (!isCurrentlyChecked && checkedCount >= MAX_LIMIT) {
        setShowPopup(true);
        setPopupType("failed");
        setPopupMessage(`You can’t select more than ${MAX_LIMIT} URLs.`);
        return;
      }
      updatedSelection[index].checkedStatus = !isCurrentlyChecked;
    } else {
      if (checkedCount >= MAX_LIMIT) {
        setShowPopup(true);
        setPopupType("failed");
        setPopupMessage(`You can’t select more than ${MAX_LIMIT} URLs.`);
        return;
      }
      updatedSelection.push({
        url: page,
        checkedStatus: true,
      });
    }

    setSelectedSitemap(updatedSelection);

    const checkedUrls = updatedSelection
      .filter((i) => i.checkedStatus)
      .map((i) => i.url);

    setSelectedUrls(checkedUrls);

    sessionStorage.setItem(
      "selectedSiteMapUrls",
      JSON.stringify(updatedSelection)
    );
    sessionStorage.setItem(
      "selectedSiteMapUrls_backup",
      JSON.stringify(updatedSelection)
    );
  };

  const handleConfirmBusinessDetails = async (status) => {
    if (!status) {
      setBusinessDetailsConfirmPopup(false);
      return;
    }

    setDisableLoading(true);

    // Save AboutBusiness form
    if (step4Ref.current?.save) {
      await step4Ref.current.save();
    }

    // Mark step complete
    addCompletedStep(3);

    // Navigate to next step (Step 4)
    const nextStep = 4;
    setCurrentStep(nextStep);
    setVisibleStep(nextStep);
    sliderRef.current?.slickGoTo(nextStep);
    scrollToTop();

    // Cleanup
    setDisableLoading(false);
    setBusinessDetailsConfirmPopup(false);
  };

  const handleBuyPlan = (data) => {
    const plansFromApple = {
      starter_month: "com.rexpt.starter.monthly",
      starter_year: "com.rexpt.starter.yearly",
      scaler_month: "com.rexpt.scaler.monthly",
      scaler_year: "com.rexpt.scaler.yearly",
      growth_month: "com.rexpt.growth.monthly",
      growth_year: "com.rexpt.growth.yearly",
      corporate_month: "com.rexpt.corporate.monthly",
      corporate_year: "com.rexpt.corporate.yearly",
    };
    // Normalize name + interval into a key (lowercased to match dictionary)
    const key = `${data.planName.toLowerCase()}_${data.interval.toLowerCase()}`;
    // Lookup product ID from Apple mapping
    const appleProductId = plansFromApple[key];
    if (!appleProductId) {
      console.warn("⚠️ No matching Apple product found for:", key);
      return;
    }

    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: "CHECKOUT",
          productId: appleProductId,
        })
      );
    } else {
      console.warn("ReactNativeWebView not available — running in browser");
    }
  };
  useEffect(() => {
    // fetch("/animations/Bodomwgicz.json")
    fetch("/animations/custom_Loader.json")
      .then((res) => res.json())
      .then((data) => setAnimationData(data))
      .catch((err) => console.error("Error loading animation:", err));
  }, []);
  //handle condition
  if (customLoader) {
    return (
      <>
        <div className={styles.container_animation}>
          <br />
          <div className={styles.Logo_animation}>
            <img src="/svg/Rexpt-Logo.svg" alt="Rexpt-Logo" />
          </div>
        </div>
        <div className={styles.animationContainer}>
          <div className={styles.animationContent}>
            <LottieAnimation
              animationData={animationData}
              width={300}
              height={300}
            />

            <p className={styles.loaderText}>
              <b>Setting up your agent... </b>
              <br />
              <br /> Please Wait
            </p>
          </div>
        </div>
      </>
    );
  }

  if (!shouldShowThankYou && isInitializingStep) {
    return (
      <div className={styles.initLoaderWrapper}>
        <Loader size={32} />
      </div>
    );
  }

  return (
    <>
      {shouldShowThankYou ? (
        <Thankyou
          onSubmit={hanldeAgentCreation}
          isAgentCreated={isAgentCreated}
        />
      ) : (
        <div className={styles.container}>
          <StepHeader
            title={step?.title}
            subTitle={step?.subTitle}
            // icon={step.icon}
            tooltip={<Tooltip content={tooltipContentMap[currentStep]} />}
          />
          <Slider ref={sliderRef} {...settings}>
            {/* business-details */} {/* Step 1 */}
            {currentStep === 0 && (
              <div>
                <BusinessDetails
                  ref={step1Ref}
                  onNext={handleNext}
                  onBack={handleBack}
                  onValidationError={handleValidationError}
                  isActive={currentStep === 0}
                  onSuccess={(data) => {
                    setShowPopup(true);
                    setPopupType("success");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  onFailed={(data) => {
                    setShowPopup(true);
                    setPopupType("failed");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  loading={loading}
                  setLoading={setLoading}
                  onStepChange={(step) => {
                    setCurrentStep(step);
                    setVisibleStep(step);
                    sliderRef.current?.slickGoTo(step);
                  }}
                />
              </div>
            )}
            {currentStep === 1 && (
              <div>
                <BusinessServices
                  ref={step3Ref}
                  onNext={handleNext}
                  onBack={handleBack}
                  onValidationError={handleValidationError}
                  // isActive={currentStep === 1}
                  onSuccess={(data) => {
                    setShowPopup(true);
                    setPopupType("success");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  onFailed={(data) => {
                    setShowPopup(true);
                    setPopupType("failed");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  loading={loading}
                  setLoading={setLoading}
                  onStepChange={(step) => {
                    setCurrentStep(step);
                    setVisibleStep(step);
                    sliderRef.current?.slickGoTo(step);
                  }}
                />
              </div>
            )}
            {currentStep === 3 && (
              <div>
                <AboutBusiness
                  ref={step4Ref}
                  onNext={handleNext}
                  onBack={handleBack}
                  onValidationError={handleValidationError}
                  isActive={currentStep === 3}
                  isBusinssDetailsPopup
                  onSuccess={(data) => {
                    setShowPopup(true);
                    setPopupType("success");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  onFailed={(data) => {
                    setShowPopup(true);
                    setPopupType("failed");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  onSiteMap={(data) => {
                    setShowSiteMapModal(Boolean(data.status));
                    setShowSiteMapUrls(data.data || []);
                    setAddOnUrl(data.addOnUrl);
                  }}
                  onRequestNoGMBConfirm={({ onConfirm, onCancel }) => {
                    noGMBHandlersRef.current = { onConfirm, onCancel };
                    setShowNoGMBModal(true);
                  }}
                  selectedSiteMapUrls={selectedUrls}
                  loading={loading}
                  setLoading={setLoading}
                  onStepChange={(step) => {
                    setCurrentStep(step);
                    setVisibleStep(step);
                    sliderRef.current?.slickGoTo(step);
                  }}
                  onBusinessDetailsFetched={handleBusinessDetailsPopup}
                  onConfirmBusinessDetails={handleConfirmBusinessDetails}
                />
              </div>
            )}
            {currentStep === 4 && (
              <div>
                <BusinessListing
                  ref={step5Ref}
                  onNext={handleNext}
                  onBack={handleBack}
                  onValidationError={handleValidationError}
                  isActive={currentStep === 4}
                  isSiteMapView={handleIsSiteMapView}
                  onSuccess={(data) => {
                    setShowPopup(true);
                    setPopupType("success");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  onFailed={(data) => {
                    setShowPopup(true);
                    setPopupType("failed");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  loading={loading}
                  setLoading={setLoading}
                  onStepChange={(step) => {
                    setCurrentStep(step);
                    setVisibleStep(step);
                    sliderRef.current?.slickGoTo(step);
                  }}
                />
              </div>
            )}
            {currentStep === 5 && (
              <div>
                <Step1
                  ref={step6Ref}
                  onNext={handleNext}
                  onBack={handleBack}
                  onValidationError={handleValidationError}
                  isActive={currentStep === 5}
                  onSuccess={(data) => {
                    setShowPopup(true);
                    setPopupType("success");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  onFailed={(data) => {
                    setShowPopup(true);
                    setPopupType("failed");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  loading={loading}
                  setLoading={setLoading}
                  onStepChange={(step) => {
                    setCurrentStep(step);
                    setVisibleStep(step);
                    sliderRef.current?.slickGoTo(step);
                  }}
                />
              </div>
            )}
            {currentStep === 6 && (
              <div>
                <Step2
                  ref={step7Ref}
                  onNext={handleNext}
                  onBack={handleBack}
                  onValidationError={handleValidationError}
                  isActive={currentStep === 6}
                  onSuccess={(data) => {
                    setShowPopup(true);
                    setPopupType("success");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  onFailed={(data) => {
                    setShowPopup(true);
                    setPopupType("failed");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  loading={loading}
                  setLoading={setLoading}
                  onStepChange={(step) => {
                    setCurrentStep(step);
                    setVisibleStep(step);
                    sliderRef.current?.slickGoTo(step);
                  }}
                />
              </div>
            )}
            {currentStep === 7 && (
              <div>
                <Step3
                  ref={step8ARef}
                  onNext={handleNext}
                  onBack={handleBack}
                  onValidationError={handleValidationError}
                  isActive={currentStep === 7}
                  onSuccess={(data) => {
                    setShowPopup(true);
                    setPopupType("success");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  onFailed={(data) => {
                    setShowPopup(true);
                    setPopupType("failed");
                    setPopupMessage(data.message);
                    setTimeout(() => {
                      setShowPopup(false);
                    }, 2000);
                  }}
                  loading={loading}
                  setLoading={setLoading}
                  onStepChange={(step) => {
                    setCurrentStep(step);
                    setVisibleStep(step);
                    sliderRef.current?.slickGoTo(step);
                  }}
                  setAvtarChecked={setAvtarChecked}
                />
                {avtarChecked && (
                  <Step4
                    ref={step8BRef}
                    onNext={handleNext}
                    onBack={handleBack}
                    onValidationError={handleValidationError}
                    isActive={currentStep === 7}
                    onSuccess={(data) => {
                      setShowPopup(true);
                      setPopupType("success");
                      setPopupMessage(data.message);
                      setTimeout(() => {
                        setShowPopup(false);
                      }, 2000);
                    }}
                    onFailed={(data) => {
                      setShowPopup(true);
                      setPopupType("failed");
                      setPopupMessage(data.message);
                      setTimeout(() => {
                        setShowPopup(false);
                      }, 2000);
                    }}
                    loading={loading}
                    setLoading={setLoading}
                    onStepChange={(step) => setCurrentStep(step)}
                    detectRoleTypeChange={detectRoleTypeChange}
                  />
                )}
              </div>
            )}
          </Slider>
          {/* Nitish code */}
          <div className={styles.footerFixed}>
            <div className={styles.stepsIndicator}>
              {[...Array(totalSlides)].reduce((acc, _, idx) => {
                if (idx === 2) return acc;

                const isClickable =
                  idx <= currentStep || completedSteps.includes(idx);
                const isCompleted = completedSteps.includes(idx);
                const isCurrent = currentStep === idx;
                const isUpcoming = !isCompleted && !isCurrent;

                let stepClass = styles.stepNumber;
                if (isCompleted && !isCurrent)
                  stepClass += ` ${styles.completedStep}`;
                if (isCurrent) stepClass += ` ${styles.activeStepNumber}`;
                if (isUpcoming) stepClass += ` ${styles.upcomingStep}`;

                acc.push(
                  <button
                    key={idx}
                    disabled={!isClickable}
                    className={stepClass}
                    onClick={async () => {
                      if (!isClickable || isContinueClicked) return;

                      const validations = {
                        0: step1Ref,
                        1: step3Ref,
                        3: step4Ref,
                        4: step5Ref,
                        5: step6Ref,
                        6: step7Ref,
                        7: [step8ARef, step8BRef],
                      };

                      if (idx > currentStep) {
                        for (let i = currentStep; i < idx; i++) {
                          if (completedSteps.includes(i)) continue;

                          const ref = validations[i];
                          if (ref?.current?.validate) {
                            const isValid = await ref.current.validate();
                            if (!isValid) return;

                            if (ref?.current?.save) {
                              await ref.current.save();
                            }

                            addCompletedStep(i);
                          }
                        }
                      }

                      setCurrentStep(idx);
                      setVisibleStep(idx);
                      sliderRef.current?.slickGoTo(idx);
                    }}
                  >
                    {isCompleted && !isCurrent ? <span /> : acc.length + 1}
                  </button>
                );

                return acc;
              }, [])}
            </div>

            {currentStep === 7 && allPlans.length > 0 && (
              <div className={styles.PlansSelectDrop}>
                <select
                  name="plans"
                  id="plans"
                  value={selectedPriceId}
                  onChange={(e) => {
                    const newPriceId = e.target.value;
                    setSelectedPriceId(newPriceId);
                    sessionStorage.setItem("priceId", newPriceId);
                    const selectedPlan = allPlans.find(
                      (plan) => plan.priceId === newPriceId
                    );
                    if (selectedPlan) {
                      sessionStorage.setItem(
                        "selectedPlan",
                        selectedPlan.title
                      );
                    }
                  }}
                >
                  {allPlans.map((plan, index) => (
                    <option key={index} value={plan.priceId}>
                      {plan.title}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {/* //Button */}
            {currentStep === 7 ? (
              <button className={styles.navBtn} onClick={handleSubmit}>
                {loading ? (
                  <>
                    <Loader size={20} />
                  </>
                ) : (
                  <img
                    src="svg/arrow.svg"
                    alt="arrow"
                    className={styles.arrowIcon}
                  />
                )}
              </button>
            ) : (
              <button className={styles.navBtn} onClick={handleNext}>
                {loading ? (
                  <>
                    <Loader size={20} />
                  </>
                ) : (
                  <img
                    src="svg/arrow.svg"
                    alt="arrow"
                    className={styles.arrowIcon}
                  />
                )}
              </button>
            )}
          </div>
          {showPopup && (
            <PopUp
              type={popupType}
              onClose={() => handleClosePopup()}
              message={popupMessage}
            />
          )}{" "}
          {/* child component helper */}
          <ConfirmModal
            open={showNoGMBModal}
            title="Continue without a Google Business Profile?"
            message="Important Notice: Linking your Google Business Profile is crucial for our agent to understand your business accurately and provide effective results. Continue without linking your profile?"
            cancelText="Go back"
            confirmText="Continue"
            onClose={() => {
              setShowNoGMBModal(false);
              noGMBHandlersRef.current?.onCancel?.();
            }}
            onConfirm={() => {
              setShowNoGMBModal(false);
              noGMBHandlersRef.current?.onConfirm?.();
            }}
          />
          {businessDetailsConfirmPopup && (
            <Modal2
              disabled={disableLoading}
              className={styles.disableModal}
              isOpen={businessDetailsConfirmPopup}
              onClose={() => {
                if (disableLoading) return;
                setBusinessDetailsConfirmPopup(false);
                setBusinessDetailsModalSource(null);
              }}
              type="info"
            >
              <div
                className={`${styles.gmbWrapper} ${
                  disableLoading ? styles.disabledCard : ""
                }`}
              >
                <h2 className={styles.gmbTitle}>
                  Confirm your <br /> Google Business listing
                </h2>

                <div className={styles.gmbInfoBox}>
                  <div className={styles.gmbRow}>
                    <span className={styles.label}>Business Name</span>
                    <span
                      className={styles.value}
                      title={
                        businessDetails?.businessName ||
                        getBusinessNameFromGoogleListing?.businessName ||
                        ""
                      }
                    >
                      {businessDetails?.businessName ||
                        getBusinessNameFromGoogleListing?.businessName ||
                        ""}
                    </span>
                  </div>

                  <div className={styles.gmbRow}>
                    <span className={styles.label}>Phone Number</span>
                    <span
                      className={styles.value}
                      title={
                        businessDetails?.phone ||
                        getBusinessNameFromGoogleListing?.internationalPhone ||
                        getBusinessNameFromGoogleListing?.phone ||
                        ""
                      }
                    >
                      {businessDetails?.phone ||
                        getBusinessNameFromGoogleListing?.internationalPhone ||
                        getBusinessNameFromGoogleListing?.phone ||
                        ""}
                    </span>
                  </div>

                  <div className={styles.gmbRow}>
                    <span className={styles.label}>Address</span>
                    <span
                      className={styles.value}
                      title={
                        businessDetails?.address ||
                        getBusinessNameFromGoogleListing?.address ||
                        ""
                      }
                    >
                      {businessDetails?.address ||
                        getBusinessNameFromGoogleListing?.address ||
                        "-"}
                    </span>
                  </div>

                  <div className={styles.gmbRow}>
                    <span className={styles.label}>Business Email</span>
                    <span
                      className={styles.value}
                      title={
                        businessDetails?.businessEmail ||
                        getBusinessNameFromGoogleListing?.email ||
                        ""
                      }
                    >
                      {businessDetails?.businessEmail ||
                        getBusinessNameFromGoogleListing?.email ||
                        "-"}
                    </span>
                  </div>

                  <div className={styles.gmbRow}>
                    <span className={styles.label}>Website</span>
                    <span
                      className={styles.value}
                      title={
                        businessDetails?.website ||
                        getBusinessNameFromGoogleListing?.website ||
                        ""
                      }
                    >
                      {businessDetails?.website ||
                        getBusinessNameFromGoogleListing?.website ||
                        "-"}
                    </span>
                  </div>
                </div>

                <div className={styles.gmbActions}>
                  <button
                    className={styles.btnGrey}
                    onClick={() => handleConfirmBusinessDetails(false)}
                  >
                    <img src="/svg/btn-gray-shape.svg" alt="btn-gray-shape" />
                    <p>NO, Incorrect</p>
                  </button>

                  <button
                    className={styles.btnPrimary}
                    disabled={disableLoading}
                    onClick={() => handleConfirmBusinessDetails(true)}
                  >
                    <img src="/svg/btn-purpol-shape.svg" alt="btn-gray-shape" />
                    {disableLoading ? (
                      <p className={styles.text}>Processing...</p>
                    ) : (
                      <p className={styles.text}>Yes, It's Mine</p>
                    )}
                  </button>
                </div>
              </div>
            </Modal2>
          )}
          {siteMapView && (
            <Modal2 isOpen={siteMapView} onClose={() => setSiteMapView(false)}>
              <div className={styles.wrapper}>
                <h2 className={styles.title}>List of pages</h2>
                <h3 className={styles.subtitle}>From Your Website</h3>
                <div className={styles.rowWrapper}>
                  {/* 1 */}
                  {sitemapUrls.map((page) => (
                    <div
                      className={styles.row}
                      onClick={(e) => {
                        // Prevent toggle when clicking checkbox directly
                        if (e.target.type !== "checkbox") {
                          handleSiteMapUrlsCheckbox(page);
                        }
                      }}
                    >
                      <p className={styles.pageUrl} title={page}>
                        {page.length > 30 ? page.slice(0, 40) + "..." : page}
                      </p>
                      <input
                        type="checkbox"
                        className={styles.checkbox}
                        checked={selectedSitemap.some(
                          (item) => item.url === page && item.checkedStatus
                        )}
                        onChange={() => handleSiteMapUrlsCheckbox(page)}
                      />
                    </div>
                  ))}
                </div>
              </div>
              <div onClick={handleConfirmSitemap} className={styles.btnTheme}>
                <AnimatedButton label="Confirmed" positionType="relative" />
              </div>
            </Modal2>
          )}
        </div>
      )}
    </>
  );
};

export default Step;
